module.exports = __webpack_public_path__ + "static/media/bleeding.343f8dbb.png";